<ng-container>
  <button class="btn btn-light btn-sm active" (click)="arrowClicked.emit(true)">
    <i
      class="la"
      [ngClass]="!isExpanded ? 'la-arrow-left' : 'la-arrow-right'"
    ></i>
  </button>
</ng-container>
